import React, { Component } from 'react';
import LoginForm from './LoginForm.jsx';
import PasswordResetIssueTokenForm from './password_reset/PasswordResetIssueTokenForm.jsx';
import '../../../stylesheets/components/login.scss';

class Login extends Component {
  state = {
    currentView: 'loginForm',
  };

  showLogin = () => {
    this.setState({
      currentView: 'loginForm',
    });
  }

  showPasswordReset = () => {
    this.setState({
      currentView: 'passwordReset',
    });
  }

  renderContent = () => {
    if (this.state.currentView === 'loginForm') {
      return <LoginForm onShowPasswordReset={this.showPasswordReset} />;
    }

    return <PasswordResetIssueTokenForm onShowLogin={this.showLogin} />;
  }

  render() {
    return (
      <div className="center-panel">
        {this.renderContent()}
      </div>
    );
  }
}
export default Login;
